<template>
<standard-dialog v-model="visible" scrollable persistent>

  <template slot="title">
    <span class="title">{{ $t('device.edit')}}</span>
  </template>

  <v-form ref="form" v-model="validEditor" lazy-validation>
    <name-text-field v-model="nameText" autofocus></name-text-field>
  </v-form>

  <device-detail :item="item" :eventlog="eventlog"></device-detail>

  <template slot="actions">
    <v-spacer></v-spacer>
    <v-btn :disabled="!canSave" :loading="saving" flat color="primary" @click="save">{{ $t('device.save') }}</v-btn>
  </template>

</standard-dialog>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import Dialog from '@/components/utils/Dialog'
import NameTextField from '@/components/utils/NameTextField'
import DeviceDetail from './DeviceDetail'

export default {
  name: 'DeviceEditorDialog',
  mixins: [UserAuth],
  components: {
    'standard-dialog': Dialog,
    'name-text-field': NameTextField,
    'device-detail': DeviceDetail
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object
    },
    eventlog: {
      type: Object
    }
  },
  data() {
    return {
      saving: false,
      validEditor: false,
      nameText: null
    }
  },
  watch: {
    targetName(val) {
      if (this.saving) {
        if (val == this.nameText) {
          this.visible = false;
        }
      }
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    targetName() {
      return ((this.userTargetName[this.item.mac] || {})[this.item.uid] || {})[this.item.cid]
    },
    canSave() {
      return this.nameText != this.item.targetName;
    }
  },
  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      let ref = this.$db.ref('command/gateway').push();
      try {
        await ref.set({
          cmd: 'settargetname',
          mac: this.item.mac,
          uid: this.item.uid,
          cid: this.item.cid,
          val: this.nameText
        });
      } catch (err) {
        this.$emit('toast', this.$t('device.permission_denied'));
        this.saving = false;
        return;
      }
      await this.refreshMac(this.item.mac);
      let refErr = ref.child('error');
      refErr.on('value', snapshot => {
        let val = snapshot.val();
        if (val) {
          ref.remove();
          this.$emit('toast', val);
          this.saving = false;
        }
      });

      setTimeout(() => {
        refErr.off();
      }, 5000);
    }
  },
  mounted() {
    this.$refs.form.reset();
    this.nameText = this.item.targetName;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/device/DeviceEditorDialog.vue